import { ComponentProps } from 'react';
import { Link, matchPath, useLocation } from 'react-router';

import { COOKIE_NAMES, getCookie, routes } from '@fly/shared';
import { Link as RadixLink } from '@radix-ui/themes';

import { BreadcrumbComponent } from '../FlyBreadcrumbs/FlyBreadcrumbs';

export const BaseBreadcrumb: BreadcrumbComponent = ({
  isLast,
}: ComponentProps<BreadcrumbComponent>) => {
  const { pathname } = useLocation();

  let to: string = routes.DASHBOARD.REGISTRY.ROOT;

  if (
    matchPath(routes.DASHBOARD.REGISTRY.STANDALONE_ARTIFACT_VERSIONS, pathname)
  ) {
    to = routes.DASHBOARD.REGISTRY.ARTIFACTS;
  }

  const title = getCookie(COOKIE_NAMES.TEAM_NAME);

  return isLast ? (
    <RadixLink className='text-fly-general-black'>
      <strong>{title}</strong>
    </RadixLink>
  ) : (
    <RadixLink asChild color='gray'>
      <Link className='font-semibold' to={to}>
        {title}
      </Link>
    </RadixLink>
  );
};
